// extracted by mini-css-extract-plugin
export default {"projectItem":"ProjectManager_projectItem__ftiKo"};